//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../SelectInput/index";
export default {
  components: {
    SelectInput: SelectInput
  },
  props: ['IpList'],
  data: function data() {
    return {
      SNAT: [{
        index: '',
        action: 1,
        sname: '',
        options: {
          enabled: false,
          name: '',
          proto: 'all',
          src: 'lan',
          src_ip: '',
          dest: 'wan',
          dest_ip: '',
          src_dip: '',
          target: 'SNAT'
        }
      }],
      protoOptions: [{
        value: "TCP",
        label: this.$t("lang.ConfigSetting.TCP")
      }, {
        value: "UDP",
        label: this.$t("lang.ConfigSetting.UDP")
      }, {
        value: "tcp udp",
        label: this.$t("lang.ConfigSetting.TCP_UDP")
      }, {
        value: "ICMP",
        label: this.$t("lang.ConfigSetting.ICMP")
      }, {
        value: "all",
        label: 'All protocals'
      }, {
        value: this.$t("lang.ConfigSetting.custom"),
        label: this.$t("lang.ConfigSetting.custom")
      }],
      SRCOptions: [{
        value: "wan",
        label: "wan"
      }, {
        value: "lan",
        label: "lan"
      }, {
        value: "DROP",
        label: this.$t("lang.ConfigSetting.anyoneDest")
      }],
      srcInputShow: false,
      destIpInputShow: false
    };
  },
  methods: {
    // 清空数据
    clearData: function clearData() {
      this.SNAT = [{
        index: '',
        action: 1,
        sname: '',
        options: {
          enabled: false,
          name: '',
          proto: 'all',
          src: 'lan',
          src_ip: '',
          dest: 'wan',
          dest_ip: '',
          src_dip: '',
          target: 'SNAT'
        }
      }];
    },
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput: function IpSelectInput(props, index) {
      this.SNAT[index[0]].options["".concat(index[1])] = props;
    },
    addRedirect: function addRedirect(row) {
      this.$emit('addRedirect', this.SNAT[0]);
      this.clearData();
    },
    // 监听选择下拉框的变化
    srcChange: function srcChange(val, index) {
      var _this = this;

      if (val === '自定义') {
        this.SNAT[index].options.src_dip = '';
        this.srcInputShow = true;
        this.$nextTick(function () {
          _this.$refs.src.focus();
        });
      }
    },
    srcBlur: function srcBlur() {
      this.srcInputShow = false;
    },
    // 监听选择下拉框的变化
    destIpChange: function destIpChange(val, index) {
      var _this2 = this;

      if (val === '自定义') {
        this.SNAT[index].options.dest_ip = '';
        this.destIpInputShow = true;
        this.$nextTick(function () {
          _this2.$refs.destIp.focus();
        });
      }
    },
    destIpBlur: function destIpBlur() {
      this.destIpInputShow = false;
    }
  }
};